module.exports = __webpack_public_path__ + "img/absolute-rock.ce330cc2.png";